export default __webpack_public_path__ + "static/media/pencil-2.21a47c32.svg";